import { render, staticRenderFns } from "./application_status.vue?vue&type=template&id=b39309d6&scoped=true"
import script from "./application_status.vue?vue&type=script&lang=js"
export * from "./application_status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39309d6",
  null
  
)

export default component.exports